<div class="d-flex align-items-center mb-3">
  <h3 class="mb-0 me-3">Screenshot stream</h3>
  <div class="form-check me-3">
    <input class="form-check-input" type="checkbox" id="live" [checked]="live" (change)="toggleLive()">
    <label class="form-check-label" for="live">live</label>
  </div>
  <button type="button" class="btn btn-sm btn-secondary" (click)="reload()">reload</button>
</div>

@for (host of hostNames; track host) {
  @let shot = screenshotOf(host);
  <div class="card mb-3">
    <div class="card-header d-flex justify-content-between align-items-center">
      <span>
        <strong>{{host}}</strong>
        @if (shot) {
          <span class="host-info ms-2">
            {{shot.captured | date:'yyyy-MM-dd HH:mm:ss.SSS'}}
            &middot; #{{shot.sequence}}
            &middot; every {{shot.intervalMillis}} ms
            &middot; {{shot.screenCount}} screen(s)
            &middot; {{shot.imageBytes / 1024 | number:'1.0-0'}} KiB
            &middot; captured in {{shot.captureMillis}} ms
            &middot; {{shot.osName}} {{shot.osVersion}}
          </span>
        }
      </span>
      <span>
        <button type="button" class="btn btn-sm btn-primary me-1" (click)="startScreenshotStream(host)">start screenshot stream</button>
        <button type="button" class="btn btn-sm btn-primary" (click)="endScreenshotStream(host)">end screenshot stream</button>
      </span>
    </div>
    <div class="card-body">
      @if (shot) {
        @for (screen of shot.screens; track screen.index) {
          <div class="row" [class.mt-3]="!$first">
            <div class="col-lg-8">
              <img class="screenshot" [src]="dataUrl(shot, screen)" [alt]="'screen ' + screen.index + ' of ' + host">
            </div>
            <div class="col-lg-4">
              <table class="table table-sm metadata">
                <thead class="visually-hidden">
                  <tr><th scope="col">Property</th><th scope="col">Value</th></tr>
                </thead>
                <tbody>
                  <tr><td>screen</td><td>{{screen.index}}{{screen.primary ? ' (primary)' : ''}}</td></tr>
                  <tr><td>resolution</td><td>{{screen.width}} x {{screen.height}}</td></tr>
                  <tr><td>desktop area</td><td>{{screen.boundsWidth}} x {{screen.boundsHeight}} at {{screen.boundsX}}, {{screen.boundsY}}</td></tr>
                  <tr><td>scale factor</td><td>{{screen.scaleFactor | number:'1.0-2'}}</td></tr>
                  <tr><td>refresh rate</td><td>{{screen.refreshRate}} Hz</td></tr>
                  <tr><td>bit depth</td><td>{{screen.bitDepth}}</td></tr>
                  <tr><td>size</td><td>{{screen.imageBytes / 1024 | number:'1.0-0'}} KiB {{shot.format}}</td></tr>
                  <tr><td>capture took</td><td>{{screen.captureMillis}} ms</td></tr>
                  <tr><td>device</td><td class="break">{{screen.deviceId}}</td></tr>
                  <tr><td>stream uid</td><td class="break">{{shot.uid}}</td></tr>
                </tbody>
              </table>
            </div>
          </div>
        }
      } @else {
        <div class="text-muted">no screenshot received yet, start the screenshot stream to get one</div>
      }
    </div>
  </div>
} @empty {
  <div class="text-muted">no stracli hosts known</div>
}
